export default "__VITE_ASSET__43324d65__"